/**
 * Formats a date + optional end time as "June 3, 2026 / 3:00PM - 3:40PM PDT".
 * Used for display in the watermark date picker and stored in settings.text.value.
 */
export const formatWatermarkDateTime = (startDate: Date, endDate: Date | null, tz: string): string => {
  const dateParts = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).formatToParts(startDate);
  const get = (type: string) => dateParts.find((p) => p.type === type)?.value ?? '';
  const dateStr = `${get('month')} ${get('day')}, ${get('year')}`;

  const formatTime = (date: Date) =>
    new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit', hour12: true })
      .format(date)
      .replace(/[\s\u202f](AM|PM)$/i, '$1'); // "3:00 PM" → "3:00PM"

  const tzAbbr =
    new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' })
      .formatToParts(startDate)
      .find((p) => p.type === 'timeZoneName')?.value ?? '';

  const startTimeStr = formatTime(startDate);
  if (endDate) {
    return `${dateStr} / ${startTimeStr} - ${formatTime(endDate)} ${tzAbbr}`;
  }
  return `${dateStr} / ${startTimeStr} ${tzAbbr}`;
};
